import BaseChartMore from './BaseChartMore';

export default BaseChartMore;
